@if (this.documentId()) {
  <a
    role="button"
    class="link-primary border-0 bg-transparent"
    (click)="onClickShowDocument($event)"
    translate
  >PAYMENT_LBL_SHOW_DOCUMENT</a>
}
